var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"py-1"},[_c('div',{staticClass:"container px-4 px-lg-5"},[_vm._m(0),_c('p',{staticClass:"m-0 text-center text-white"},[_c('small',[_c('em',[_vm._v("Version: "+_vm._s(_vm.version))])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m-0 text-center text-white"},[_vm._v(" Copyright © - Designed and Created by: "),_c('strong',[_vm._v("Carlos Mur")])])
}]

export { render, staticRenderFns }